var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeffreysmacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.44 430.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4, .cls-5 {\n        stroke: #474748;\n      }\n\n      .cls-1, .cls-7 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #6d6d6d;\n        stroke: #6d6d6d;\n      }\n\n      .cls-9 {\n        fill: #d7d7d7;\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #545554;\n        stroke: #545554;\n      }\n\n      .cls-4 {\n        fill: #484848;\n      }\n\n      .cls-5 {\n        fill: #474748;\n      }\n\n      .cls-6 {\n        fill: #b6b6b6;\n        stroke: #b6b6b6;\n      }\n\n      .cls-7 {\n        stroke: #ddd;\n      }\n\n      .cls-8 {\n        fill: #a7a7a7;\n        stroke: #a7a7a7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colour_mirror",
    "data-name": "Colour mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M316.22,323.8l-9.2,3.6-2.4-2.5,2.3-20.2-30.8-15.2-30.9,5.2-30.9-5.2-30.8,15.2,2.3,20.2-2.4,2.5-9.2-3.6-5.2,4.2v7.7l14.5,19.2,5.2,3,6.8-1.2s11.1,22.2,20.2,28.8c9.2,6.6,15.7,10.5,15.7,10.5l13.8,1.1h0l13.8-1.1s6.5-4,15.7-10.5c9.2-6.6,20.2-28.8,20.2-28.8l6.9,1.2,5.2-3,14.5-19.2v-7.7l-5.2-4.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M175.42,334.2s-.8.9,2,4.8c2,2.7,3.9,7.1,6.2,8.3,0,0-.7-9.7-2.1-11.2s-6.2-1.8-6.2-1.8h0l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.22,355.5s-5-1.5-6.6-1.1c-3.2.8-4,2.3-4,2.3,0,0,7.9,2.4,10.6,2.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M315.12,334.2s.8.9-2,4.8c-2,2.7-3.9,7.1-6.2,8.3,0,0,.7-9.7,2.1-11.2s6.2-1.8,6.2-1.8h0l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.22,355.5s5-1.5,6.6-1.1c3.2.8,4,2.3,4,2.3,0,0-7.9,2.4-10.6,2.4"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.92,324.9s-3.3,4.1-4,5.9,1.3,23.6,1.3,23.6l1.1,2.8s9.2-2.2,9.2-5.2-5.8-21.2-5.8-21.2c0,0,6.2-8,14.4-5.9,3.7.9-3-1.9-3-1.9l-13.1,1.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.02,304.6s-1.5,10.4-3.4,13-13.2,10.1-13.2,10.1l20.4,4.7s-2.2,5.2-3.8,6.4-4.7,2.4-5.6,5.5-2.9,21.1-5.3,26.4-13.8,23.1-13.8,23.1c0,0,20.4-18.8,23.3-23.4s15.1-28.2,15.2-33.5,2.5-18.5,2.5-18.5l-16.1-13.7h0l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.52 290.2 162.42 300.6 173.42 316.6 173.42 323 184.52 325.6 188.72 313.4 194.02 309.9 188.62 308.1 196.42 302.4 208.12 299 217.42 300.4 213.42 293.1 224.22 293.8 229.52 294.9 239.62 294.1 244.32 294.2 255.32 293 261.32 294.6 266.42 295.1 272.52 299.5 277.52 300.5 292.22 306 294.22 312 298.92 313.9 301.62 319.3 304.12 328.8 312.92 323.8 318.92 322.7 325.82 308.2 322.42 302.7 321.92 292.6 321.12 280.1 314.52 274.2 301.62 273 296.92 268.5 293.92 265.4 286.12 264 275.42 251.7 269.72 251.3 272.62 245.7 259.62 249 241.62 249.5 224.52 254.9 216.42 262.7 215.52 252.5 215.12 248.8 201.52 259.5 193.52 263.3 183.02 272.6 174.22 277.7 170.52 290.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.02,268.1s3.1-4,14.2-6.4c6.2-1.4,12.2-3,17.7,0,0,0-10,1.1-8.6,4.8s3.5,4,13.1,5c9.6,1,11.9-.8,11.9-.8,0,0-16.5,8.9-22.2,10.5s-21.9,1.1-20.5-4.1c1.8-6.7,5.2-7.5,2.3-9.7s-7.9.7-7.9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.92,284.1s-4.7-.7-2.7,2.9,8.7,7.4,15.7,5.8,3.7-5.3,3.2-7.3-5.3-.6-7.1-.8c-3.7-.3-1.6,5.1-4.7,2.6-3.3-2.6-4.6-3.2-4.6-3.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.52,291.2c4.2-1.6,8.3,8.6,9.5,8.8s6.6,1.3,6.2,2.3-5.4,1.3-7.3,2.8c-1.9,1.5-1.3,2.5-2.3,3.4s-9.5-.8-10.6-3.9,1.1-12.1,4.6-13.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.82,288c-3-.8,3-3,3.8-4.2l3.7-1c-3.3,4.8-2.7,6.5-7.4,5.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.62,290.7c-.9.1-1.3,0-.7-.5,4.3-3.4,2.2-3.7,8.7-7.1,1.4-.8,13.1,0,14.4,2.2,2,3.4-4.7,7.4-12.2,9.4,0,0-.1,0,0,0,.1-.3.2-3.8-.4-4.4-1.9-1.8-6.4,0-9.7.5l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.02,299.4c1.9-1.6,6.9-9.6,8.3-8.4s.2,9.4-4.3,10.6-15.1,3.2-15.1,2.3,9.5-3.1,11.1-4.5h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,398.1s4,0,11.1-1.3c12.3-2.4,27.2-19,34.3-29.5,7.4-11,14.9-38.5,14.9-38.5,0,0,6.2-6.3,12-4.7s4.7,10.5,3.7,12.2-11.2,19-17.3,21.8c-3.7,1.7-7.4-1.4-7.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.12,333.3s.5-1.7-1.4-1.7-6.6,4.1-7.5,7.3.4,6.7-1,9.8c-1.1,2.4-2.6,2.6-2.6,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.92,314.7s-9.7,4.6-16.5,5.9c-4.1.8-20.8,3.7-21.4,4.3-2.8,2.6-1.7,5.1-.8,5.2,1.1.1,19.8-5.6,24.5-7.3,6.3-2.2,14.2-8.1,14.2-8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.92,333.4s9.2-4.6,14.3-4.6c7.7,0,20.7,4.6,20.7,4.6,0,0-14.9-2-17.9-1.8s-17.1,1.8-17.1,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.62,356.8s-1.1-.2-2,0-2.1,1.1-2.1,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.32,323.8s-.9,2.8-2.3,3.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,398.1s-4,0-11.1-1.3c-12.3-2.4-27.2-19-34.3-29.5-7.5-11-14.9-38.5-14.9-38.5,0,0-6.2-6.3-12-4.7s-4.7,10.5-3.7,12.2,11.2,19,17.3,21.8c3.7,1.7,7.4-1.4,7.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.32,333.3s-.5-1.7,1.3-1.7,6.6,4.1,7.5,7.3-.4,6.7,1,9.8c1.1,2.4,2.6,2.6,2.6,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.62,314.7s9.7,4.6,16.5,5.9c4.1.8,20.8,3.7,21.4,4.3,2.8,2.6,1.7,5.1.8,5.2-1.1.1-19.8-5.6-24.5-7.3-6.3-2.2-14.2-8.1-14.2-8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.52,333.4s-9.2-4.6-14.3-4.6c-7.7,0-20.7,4.6-20.7,4.6,0,0,14.9-2,17.9-1.8s17.1,1.8,17.1,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.82,356.8s1.1-.2,2,0,2.1,1.1,2.1,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.22,323.8s.9,2.8,2.3,3.9"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.02,328.7s2.2-11.1,4-13.5,7.4-5.6,7.4-5.6l-5.7-1.4s1.9-3.2,4.9-4.5c3-1.4,12.5-3.2,12.5-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.02,324.1c-2.2-2.9-.7-6.4-.7-6.4-3.3-3.3-9.9-10.8-9.9-17,0-7.7,8.2-11.5,8.2-11.5,0,0-2.2-8.6,1.7-11.5s5-1.3,5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.82,277.7s-.7.7-1,5.9c-.5,7.4,6.5,10.2,13.1,13.4,4,1.9,26.7,3.7,26.7,3.7l-5.4-6,9.1,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.12,293.8s-3.8,3.1-15.2.8c0,0-16-2.1-12.1-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.52,294.6s9.5.8,13.8-.8c11.9-4.7,16.9-13.3,16.9-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.22,282.4s-.5,8.7-13.6,13.1c-5.2,1.7-14.8-1.7-14.8-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.82,273.3c2.4-1.6,9.9,2.6-1.2,15.3-9.4,10.8-19.4,9.9-30.9,11.9-9.1,1.6-15-3.9-15-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.52,277.8s3.3.7,4.3,3.7,1.4,17.8-6.3,24.1-15.7,9.2-22.2,7c-1.9-.6-.4-3.9-.5-4.9s-12.6-2.8-14.6-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.42,292.6c1.3,2,0,7.5.9,10.8s3.7,3.7,2.4,9.2-8.1,11.4-8.1,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.72,313.4s-1.9,1-.1,4.9,3.8,3.8,4.2,9.3,0,8.8,0,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.92,269.6s-8.4,5.4-9.4,11-1.1,9.2,5.7,15.2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Anvil_Colour",
    "data-name": "Anvil Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.62,196.8s31.4,26.9,50.1,32.6c18.7,5.7,21.4,6.1,21.4,6.1l-5.4,14.8-17.3,1.1-8.2,25,35.4,1.4,4.7-16.1,20.3-7.7,22.8,1.6,12.6,9.1,5.2,12.2,33.9.4-8.4-26.4h-16.2l-3.5-23.3,29.2-19.4,29.3-14.8-9.2-13.6-118.2.8,5.1,12.7-6.1,1.2-77.5,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.32,178.8s.8,16.1-5.8,20.5-31.8,25.2-31.8,25.2l-.3,32.4s10.4,5.2,12,10.8,4.6,9.4,4.6,9.4l32.7-1.2-8.2-25.2-17.7-.5-2.3-21.6,29.7-20.7,29.3-14.8-7.7-13.6-34.5-.8v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.02,183.1h-49.7s2.3,4.5,2.2,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M205.02,199.7h-60.2s10.9,11.4,25.5,17.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Anvil_Lines",
    "data-name": "Anvil Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.62,178.8h124.4s6.9,10.2,8.5,13.7c1.6,3.5-30.9,12.6-59.4,38l3.5,19.7h15.9l9,27.7h-36.8s-.1-22.6-31.6-22.6-31.6,22.6-31.6,22.6h-36.8l9-27.7h15.9l3.7-15.1s-53.3-12.3-69.8-40.1c0,0,78.9-.4,80.2-1.2,4.5-3-4-15-4-15h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.52,282.4s9.6,4.3,16.9-3.4c6.7-7-9.8-24.8-9.8-24.8,0,0,12.3,9.9,20.3,8.8,8-1.1,11.3-5.1,11.3-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.62,250.1c6,2.1,23.8-9.3,23.8-9.3,0,0-15.3,18.1-12.1,24.6,3.7,7.4,11,7,27.6,4.5,0,0-18.1,10.9-14.6,17.8s10.3,9.4,10.3,9.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeffreysmacked);
export default __webpack_public_path__ + "static/media/jeffreysmacked.4fd774fd675aaec6d1a573ec1b6ee03a.svg";
export { ForwardRef as ReactComponent };